import { Box, IconButton, useTheme } from '@mui/material';
import React from 'react';
import WestOutlinedIcon from '@mui/icons-material/WestOutlined';

interface BackProps {
  onClickCallback: () => void;
}

const Back: React.FC<BackProps> = ({ onClickCallback }) => {
  const theme = useTheme();

  return (
    <IconButton onClick={onClickCallback}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: '1px solid ' + theme.palette.grey[500],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
        }}
      >
        <WestOutlinedIcon htmlColor={theme.palette.grey[500]} />
      </Box>
    </IconButton>
  );
};

export default Back;
